<ng-container class="no-scrollbar lottery-extension-wrapper">
  <!-- Wrapper for the lottery extension component -->
  <ion-grid class="ion-no-padding">
    <ion-row class="card-header">
      <!-- Header row for the card -->
      <h1 class="extend-title"> {{'checkout.Save' | translate}}</h1>
      <p class="extend-subtitle">{{'checkout.Benefits' | translate}}</p>
    </ion-row>
    <div class="padding-horizontal">
      @for (discount of storeOffers; track discount; let i = $index) {
        <ion-row
          class="offer-option-height border-bottom discount-option-{{i+1}}" 
          [class.offer-option-height--expanded]="discount?.type === '8_weeks' && PromoCreditBackSignal()"
          (click)="changeDiscount(discount)"
        >
          <ion-col size="7" class="discount-week">
            <ion-item class="no-ripple" lines="none">
              <ion-checkbox class="checkbox"  mode="ios" color="secondary" [disabled]="discount$.value.title === discount.title"
              [checked]="discount$.value.title === discount.title"></ion-checkbox>
              <ion-label class="discount-period">{{ (discount?._title ? discount?._title[languageCode] : discount?.title)
                | titlecase }} @if (i != 4) {
                <p class="mute-text"><span>/</span> {{i == 0 ? initialLines * offerDays : i == 1 ? (i + 1) * initialLines * offerDays : i == 2 ? i * 2 * initialLines * offerDays : (i + 1) * 2 * initialLines * offerDays}} {{
              "store-payment.Lines" | translate }} </p>
            }</ion-label>
          </ion-item>
        </ion-col>
        @if (discount?.title !== 'No extension') {
          <ion-col size="5">
            @if(discount?.type === "8_weeks" && PromoCreditBackSignal()) {
              <div class="ribbon">
                {{ "checkout.credit_back" | translate | amount : { amount: PromoCreditBackSignal() } }}
              </div>
            }
            <ion-chip [ngClass]="discount$.value.title !== discount.title ? 'discount-chip' : 'best-discount'">
              <ion-label
                [ngClass]="discount$.value.title !== discount.title ? 'discount-percentage' : 'best-discount-percentage'">
                @if (discount?.type === '8_weeks') {
                  <span> {{ (discount?._tag_text ? discount?._tag_text[languageCode] : discount?.tag_text)
                  | titlecase }} </span>
                  } -{{ discount.discount }}%
                </ion-label>
              </ion-chip>
            </ion-col>
          }
        </ion-row>
      }
      @if (selectedOfferPrices$ | async; as selectedOfferPrices) {
        <div class="total-wrapper">
          <!-- Wrapper for the total price section -->
          <span class="total-txt">{{'checkout.Total' | translate}}</span>
          <span class="total-val">{{ currencySymbol }}
            {{((selectedOfferPrices?.int_price?.[preferredCurrency]) ?
            (selectedOfferPrices?.int_price?.[preferredCurrency]) : (selectedOfferPrices?.price)) | displayCurrency}}</span>
          <span class="total-save">({{ discount$.value.discount }}% {{'checkout.saving' | translate}})</span>
        </div>
      }
      <div>
        <ion-row class="checkout-btn-wrapper">
          <!-- Row for the checkout button -->
          <ion-button size="small" expand="block" class="btn-checkout" (click)="checkOut()">
            <span>{{'checkout.Checkout' | translate}}</span>
          </ion-button>
        </ion-row>
        <ion-row>
          <h1 class="back-text link-text-blue" (click)="closeDialog()">&larr; {{'checkout.Back' | translate}}</h1>
        </ion-row>
      </div>
    </div>
  </ion-grid>
</ng-container>
